export function detectPlatform(userAgent: string): string {
    if (/Macintosh/.test(userAgent)) {
        return 'macOS'
    } else if (/Windows/.test(userAgent)) {
        return 'Windows'
    } else if (/Linux/.test(userAgent)) {
        return 'Linux'
    } else if (/Android/.test(userAgent)) {
        return 'Android'
    } else if (/iPhone|iPad|iPod/.test(userAgent)) {
        return 'iOS'
    } else if (/CrOS/.test(userAgent)) {
        return 'Chrome OS'
    } else {
        return 'Unknown'
    }
}
